module.exports = __webpack_public_path__ + "img/entete.dde8e7cd.png";